export default {
  tripId: "TripID",
  leavingDatetime: "出庫日時",
  returningDatetime: "帰庫日時",
  driver: "ドライバー",
  outOfServiceMeter: "出庫時メーター (km)",
  returnMeter: "帰庫時メーター (km)",
  totalMileage: "総走行距離 (km)",
  diff: "差分 (km)",
  applyPrevBtn: "直前の運行の帰庫時メーターを適用",
  noData: "運行がありません。",
  validation: {
    required: "入力してください。",
    negative: "0以上の値を入力してください。",
    decimalDigits: "小数点以下は5桁以内で入力してください。",
  },
};
